import React from "react";
import { translations } from "../texts";
export function BannerSignature({ languageCode, discrete }) {
    const t = translations(languageCode);
    return (React.createElement("div", { className: "biskoui-cookie-banner-signature-wrapper" },
        React.createElement("div", { className: "biskoui-cookie-banner-signature" },
            React.createElement("a", { href: "https://biskoui.ch", rel: "noopener noreferrer", target: "_blank" },
                t.home.biskouiSignaturePre,
                React.createElement("span", { className: discrete ? undefined : "biskoui-cookie-banner-signature-swiss" }, t.home.biskouiSignatureSwiss),
                t.home.biskouiSignaturePost,
                React.createElement("span", { className: "biskoui-cookie-banner-signature-biskoui" }, "biskoui")))));
}
//# sourceMappingURL=BannerSignature.js.map